import _ from 'underscore'
import {load,storageRef,saveIdObject} from './common'
import {notify} from './init'
export function loadTopos() {
  return load('topos')
}

export function uploadTopo(topo) {

  return (dispatch,getState) => {
    let {file} = topo
    notify({event:'loading'})
    console.log('uploadTopo',topo.file)

    let ref = storageRef('topos').child(Date.now()+'')
    let metadata = {'contentType': file.type}

    let uploadTask = ref.put(file, metadata);

    uploadTask.on('state_changed', null, function(error) {
      console.error('Upload failed:', error);
      notify({event:'loaded'})
    }, function() {
      console.log('Uploaded',uploadTask.snapshot.totalBytes,'bytes.');

      topo.url = uploadTask.snapshot.metadata.downloadURLs[0];
      console.log('File available at', topo.url);
      dispatch(saveTopo(topo))
      notify({event:'loaded'})
    })
  }
}

function purify(topo){
  return _.pick(topo,
    'id',
    'uid',
    'fbid',
    'name',
    'area',
    'region',
    'url',
    'markers',
    'links',
    'lines',
    'longitude',
    'latitude',
    'zoom',
    )
}

export function saveTopo(topo) {
  return (dispatch,getState) => {
    try {
      saveIdObject('topos',purify(topo))
    }
    catch(e) {
      console.error('error',e,d)
    }
  }
}





/** WEBPACK FOOTER **
 ** ./src/app/actions/topos.js
 **/